import { FC } from 'react'
import { Container } from '@components/ui'
import Link from 'next/link'
import cn from 'classnames'
import { Breadcrumb } from '@types'

interface HeroProps {
  title: string
  breadcrumbs: Array<Breadcrumb>
}

const Hero: FC<HeroProps> = ({ title, breadcrumbs }) => {
  return (
    <Container className="mt-20">
      <h1 className="text-4xl sm:text-5xl md:text-6xl xl:text-7xl">{title}</h1>
      <ul className="flex flex-wrap gap-4 items-center">
        {breadcrumbs.map((b, i) => (
          <>
            {i > 0 && <small>/</small>}
            <li key={b.label} className={cn({ 'color-wine': !!b.path})}>
              {!!b.path ? (
                <Link href={b.path}>{b.label}</Link>
              ) : (
                <span>{b.label}</span>
              )}
            </li>
          </>
        ))}
      </ul>
    </Container>
  )
}

export default Hero
